import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { TaskList } from "@/app/Tasks/Components/TaskList";
import {
  BookingChangeRequestStatus,
  ModelType,
  QueryBookingChangeRequestsWhereColumn,
  QueryTasksWhereColumn,
  SqlOperator,
  TaskStatus,
} from "@/gql/graphql";
import { ChangeRequestTable } from "@/app/Bookings/Components/ChangeRequestTable";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { useBookingRecord } from "@/app/Bookings/Hooks/useBookingRecord";
import { Button } from "@/components/catalyst/button";
import { PlusIcon } from "@heroicons/react/20/solid";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { BookingChangeRequestCreateDialog } from "@/app/Bookings/Components/Dialogs/BookingChangeRequestCreateDialog";

export function BookingTaskScreen() {
  const record = useBookingRecord();
  const { isAdmin } = useTenant();
  const { open: openCreateDialog } = useDialog(
    BookingChangeRequestCreateDialog,
  );

  return (
    <div className="space-y-10">
      <RecordScreenCard>
        <TaskList
          id={"booking-tasks"}
          queryVariables={{
            orgOnly: false,
            status: [TaskStatus.Pending, TaskStatus.Overdue],
            where: {
              AND: [
                {
                  column: QueryTasksWhereColumn.RelatedToId,
                  value: record.id,
                },
                {
                  column: QueryTasksWhereColumn.RelatedToType,
                  value: ModelType.Booking,
                },
              ],
            },
          }}
        />
      </RecordScreenCard>

      {isAdmin ? (
        <RecordScreenCard>
          <ChangeRequestTable
            rightButtons={
              <Button onClick={() => openCreateDialog({ booking: record })}>
                <PlusIcon data-slot="icon" />
                Create change request
              </Button>
            }
            queryVariables={{
              where: {
                AND: [
                  {
                    column: QueryBookingChangeRequestsWhereColumn.BookingId,
                    value: record.id,
                  },
                  {
                    column: QueryBookingChangeRequestsWhereColumn.Status,
                    operator: SqlOperator.In,
                    value: [
                      BookingChangeRequestStatus.Approved,
                      BookingChangeRequestStatus.Declined,
                      BookingChangeRequestStatus.Pending,
                      BookingChangeRequestStatus.Actioned,
                    ],
                  },
                ],
              },
            }}
            id={"booking-change-requests"}
          />
        </RecordScreenCard>
      ) : null}
    </div>
  );
}
